import {connect} from "react-redux";
import * as ChapterPartActions from "../../store/actions/chapterPartActions";
import EditBasicInfo from "../../components/EditChapterPart/EditBasicInfo";

const mapStateToProps = (state) => ({
    ...state.chapterPart
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: () => {
        dispatch(ChapterPartActions.getChapterPartInfo());
    },
    onChapterPartUpdate: (info, token) => {
        dispatch(ChapterPartActions.updateChapterPartInfo(info, token))
    },
    addChapterPart: (info, chapterId, token) => {
        info.status = false;
        dispatch(ChapterPartActions.addChapterPart(info, chapterId, token));
    },
    getChapterPart: (id, token) => {
        dispatch(ChapterPartActions.getChapterPartById(id, token));
    },
    updateChapterPart: (burger, id, token) => {
        dispatch(ChapterPartActions.updateChapterPart(burger, id, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditBasicInfo);


// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/EditBasicInfoContainer.js